const timezoneAbbreviations: { [key: string]: string } = {
    "0": "GMT",
    "-60": "CET", // Central European Time
    "-120": "EET", // Eastern European Time
    "-180": "MSK", // Moscow Standard Time
    "-240": "AST", // Arabian Standard Time
    "-270": "IRST", // Iran Standard Time
    "-300": "ET", // Eastern Time
    "-330": "IST", // Indian Standard Time
    "-345": "NPT", // Nepal Time
    "-360": "PKT", // Pakistan Standard Time
    "-390": "AFT", // Afghanistan Time
    "-420": "UZT", // Uzbekistan Time
    "-480": "CST", // China Standard Time
    "-540": "JST", // Japan Standard Time
    "-570": "ACST", // Australian Central Standard Time
    "-600": "AEST", // Australian Eastern Standard Time
    "-660": "SBT", // Solomon Islands Time
    "-720": "NZST" // New Zealand Standard Time
};

export const getCurrentTimeZoneName = () => {
    const currentTimeZoneOffset = new Date().getTimezoneOffset().toString();

    const timeZoneName = timezoneAbbreviations[currentTimeZoneOffset] || "";

    return timeZoneName;
};
